import lang from '@/lang'
import config from '@/config'
import { isIE, isOsx } from './isBrowser'
import isElectron from './isElectron'
import { toast } from '@/modules/base/components/toast/toastConfig'
import request from '@/modules/base/util/request'

export const printByPdfUrl = async(url, cb) => {
  toast.showToast({
    type: 'info',
    message: lang.generics.printingWait,
  })

  request(url, {
    isConcurrent: true,
    auth: true,
    method: 'POST',
  })
    .then(response => {
      const { path } = response.body.data
      const documentUrl = `${config.imageResourceHost}${path}`
      if (!isElectron()) {
        // returned, so a failure of the pdf fetch reaches the catch below instead of being swallowed
        return fetch(documentUrl)
          .then(r => r.blob())
          .then((data) => {
            const oldPrintFrame = document.getElementById('printFrame')

            if (oldPrintFrame) {
              oldPrintFrame.parentNode.removeChild(oldPrintFrame)
            }
            const newBlob = new Blob([data], { type: 'application/pdf' })
            const objectURL = window.URL.createObjectURL(newBlob)

            const printFrame = document.createElement('iframe')
            printFrame.id = 'printFrame'
            printFrame.name = 'printFrame'
            printFrame.style.display = 'none'
            printFrame.src = objectURL
            if (!isIE() && !isOsx()) {
              printFrame.onload = () => {
                printFrame.contentWindow.focus()
                printFrame.contentWindow.print()
                cb && cb(response)
              }
            } else {
              printFrame.onload = () => {
                setTimeout(() => {
                  printFrame.contentWindow.focus()
                  printFrame.contentWindow.print()
                  cb && cb(response)
                }, 1000)
              }
            }
            document.body.append(printFrame)
          })
      } else {
        window.electron.printByUrl(documentUrl)
      }
    })
    .catch((error) => {
      console.error(error)
      toast.showToast({
        type: 'error',
        message: lang.generics.printingError,
      })
    })
}
